<template>
  <div class="instock-bd tb" v-if="funcView.in_stock_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item v-if="funcView.in_stock_add">
          <el-button type="primary" @click="addInStock">
            <i class="icon icon-add"></i>
            {{ funcView.in_stock_add }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.in_stock_batch">
          <el-button type="primary" @click="addBatchStock">
            <i class="icon icon-piliangtianjia"></i>
            {{ funcView.in_stock_batch }}
          </el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item v-if="funcView.in_stock_export" style="float: right" :class="{ 'mr-0': funcView.in_stock_export }">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.in_stock_export }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_instock.ji_shen_haoModemSN')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 高级搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_instock.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" placeholder="" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_instock.ru_ku_dan_hao')">
          <el-input v-model="formSearch.shipmentNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_instock.ru_ku_ban_li_ren')">
          <el-input v-model="formSearch.inUser"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_instock.ru_ku_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="dataTimes"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table tableCode="device_in_stock" :data="intockList" height="100%" @filter="filterChange" @sort="sortChange" @column="setColumn"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <in-stock-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></in-stock-dialog>
    <in-stock-batch-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onPageChange({ page: 1 })"></in-stock-batch-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import inStockDialog from './children/instock_dialog';
import inStockBatchDialog from './children/instock_batch_dialog';

export default {
  name: 'instock',
  components: { inStockDialog, inStockBatchDialog },
  data() {
    return {
      provide: true,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dataTimes: [],
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
        productCode: '',
        shipmentNum: '',
        inUser: '',
        inTimeStart: '', // 入库开始时间
        inTimeEnd: '', // 入库结束时间
      },
      intockList: [],
      totalRows: 0,
      link: null,
    };
  },
  activated: function () {
    this.getInStock();
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    // this.getInStock();
  },
  methods: {
    getInStock: function () {
      this.formSearch.inTimeStart = this.dataTimes ? this.dataTimes[0] : '';
      this.formSearch.inTimeEnd = this.dataTimes ? this.dataTimes[1] : '';
      this.$getJSON(apis.InStockPage, this.formSearch).then((res) => {
        this.intockList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    addInStock: function () {
      this.dialogModel.title = this.$t('dms_instock.xin_ji_ru_ku');
      this.dialogVisible = true;
    },
    addBatchStock: function () {
      this.dialogModel1.title = this.$t('dms_instock.pi_liang_ru_ku');
      this.dialogVisible1 = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getInStock();
    },
    // 过滤
    clearFilter: function () {
      this.dataTimes = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.InStockExport, this.formSearch).then(() => {});
    },
  },
};
</script>
